import router from "@/router";

export default function findRouteByName(name: string, config: any = {}, routesArg = []) {

  const routes = routesArg.length ? routesArg : router.options.routes;
  let route: any | null = null;

  routes.forEach((_route: any | null) => {
    if (_route.name === name) {
      route = _route;
    }

    if (!route && _route.children) {
      route = findRouteByName(name, config, _route.children);
    }

    return route;
  });

  if (!route) {
    return null;
  }

  // Router records are shared configuration. Return a location-shaped copy so
  // callers cannot leak params or query values into menus and breadcrumbs.
  return {
    ...route,
    params: {
      ...(config.params ?? {}),
    },
    query: {
      ...(config.query ?? {}),
    },
  };
};
